module.exports = __webpack_public_path__ + "b778443124c1762a14b5b7edd6f20319.svg";